module.exports = __webpack_public_path__ + "img/new3.284c4e3d.webp";